<div class="language-configuration">
  <div class="item-menu-language" (click)="selectLanguage('en')">
    <div class="flag">
      <span class="fi fi-us"></span>
    </div>
    <div class="label">Inglés</div>
  </div>
  <div class="item-menu-language" (click)="selectLanguage('es')">
    <div class="flag">
      <span class="fi fi-es"></span>
    </div>
    <div class="label">Español</div>
  </div>
  <div class="item-menu-language" (click)="selectLanguage('pt')">
    <div class="flag">
      <span class="fi fi-br"></span>
    </div>
    <div class="label">Portugués</div>
  </div>
</div>
